import { render, staticRenderFns } from "./mLiveScorePage.vue?vue&type=template&id=2f329608&scoped=true"
import script from "./mLiveScorePage.vue?vue&type=script&lang=js"
export * from "./mLiveScorePage.vue?vue&type=script&lang=js"
import style0 from "./mLiveScorePage.vue?vue&type=style&index=0&id=2f329608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f329608",
  null
  
)

export default component.exports